<button appButton buttonType="create" (click)="onAdd()" [disabled]="!isButtonEnabled()">Create Story</button>
